import { createStyles, makeStyles } from "@material-ui/core/styles";
import classnames from "classnames";
import * as React from "react";

import { Chip, RelodeTheme } from "..";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            chip: {
                width: "100%",
                minHeight: 40,
                borderRadius: 32,
                justifyContent: "flex-start",
            },
        }),
    { name: "toggleChips" }
);
export interface ToggleChipsProps {
    id: string;
    onChange: (value: boolean) => void;
    trueLabelOption?: string;
    falseLabelOption?: string;
    value?: boolean;
    className?: string;
}

export const ToggleChips = (props: ToggleChipsProps) => {
    const handleChipClick = (value: boolean) => props.onChange(value);
    const classes = useStyles(props);
    const chipClassName = classnames(classes.chip, props.className);
    
    return (
        <>
            <Chip
                id={`${props.id}-toggle-true`}
                value={true}
                className={chipClassName}
                onChipClick={() => handleChipClick(true)}
                selected={props.value === true}
                label={props.trueLabelOption ?? "yes"}
                dataCy={`${props.id}-toggle-true-chip`}
            />
            <Chip
                id={`${props.id}-toggle-false`}
                value={false}
                className={chipClassName}
                onChipClick={() => handleChipClick(false)}
                selected={props.value === false}
                label={props.falseLabelOption ?? "no"}
                dataCy={`${props.id}-toggle-false-chip`}
            />
        </>
    );
};
